import { useEffect, useState } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { GET_TERRITORY_TEAM } from '../../../../../graphql/getTerritoryTeam';

export function useTerritoryTeam() {
  const { data } = useQuery(GET_TERRITORY_TEAM, { fetchPolicy: 'cache-first' });
  const [territoryTeam, setTerritoryTeam] = useState<any>(null);
  useEffect(() => {
    if (data?.getTerritoryTeam) {
      setTerritoryTeam(data.getTerritoryTeam);
    }
  }, [data]);
  return { territoryTeam };
}